module.exports = __webpack_public_path__ + "img/logo.9770a78c.png";